export default "__VITE_ASSET__ab974a4d__"